import store from "@/store";
import { compareVersions, upgradable } from "./packages";
import { getPackageNameVersionAndHash, hasParam, isSamePackage } from "./mdc";
import { isScheduleValid, objectifySchedule } from "@/utils/packageDate";

function hasValidSchedule(item) {
  return isScheduleValid(objectifySchedule(item.schedule));
}

function hasAutoUpgrade(item) {
  const packages = store.getters["groupPackage/packageGroup"]({
    p: item,
    filter: x => isAutoUpgrade(x)
  });

  return packages.length !== 0;
}

function isAutoUpgrade(item) {
  return (
    isScheduleValid(objectifySchedule(item.schedule)) &&
    item.schedule.type === 1
  );
}

function isTempAutoUpgrade(item) {
  return (
    isScheduleValid(objectifySchedule(item.tempSchedule)) &&
    item.tempSchedule.type === 1
  );
}

function isHigherVersionInstalled(item) {
  const packages = store.getters["groupPackage/packageGroup"]({
    p: item,
    filter: x => isInstallOrUpgrade(x)
  });

  if (packages.length !== 0) {
    const p1NV = getPackageNameVersionAndHash(packages[0]);
    const p2NV = getPackageNameVersionAndHash(item);
    return compareVersions(p1NV.version, p2NV.version) > 0;
  }

  return false;
}

function hasMultipleVersions(item) {
  const packages = store.getters["groupPackage/packageGroup"]({
    p: item,
    filter: x => isInstallOrUpgrade(x) && !isSamePackage(x, item)
  });

  return packages.length !== 0;
}

function isUpgradable(item) {
  if (!hasAutoUpgrade(item)) {
    const packages = store.getters["groupPackage/packageGroup"]({
      p: item,
      filter: x =>
        isInstallOrUpgrade(x) && x.command.name && !isSamePackage(item, x)
    });

    if (packages.length === 0) return true;
    else return !hasMultipleVersions(item) && upgradable(packages, item);
  }
  return false;
}

function isInstallOrUpgrade(item) {
  return item.command.name && item.command.name !== "uninstall";
}

function isInstallable(item) {
  return (
    !item.command.name || (item.command && item.command.name == "uninstall")
  );
}

function isUninstallable(item) {
  return (
    !item.command.name || (item.command && item.command.name != "uninstall")
  );
}

function isInstall(item) {
  return item.command.name === "install";
}

function isUninstall(item) {
  return item.command.name === "uninstall";
}

export default {
  isUpgradable,
  hasMultipleVersions,
  isHigherVersionInstalled,
  isAutoUpgrade,
  hasAutoUpgrade,
  hasValidSchedule,
  isInstall,
  isUninstall,
  isInstallable,
  isUninstallable,
  isTempAutoUpgrade
};
